// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import "./MvMessageModal.sass"

interface Props {
  header?: string;
  message: string;
};

class MvMessageModal extends React.Component<Props, {}> {
  render() {
    const { localize } = this.context;
    const {header, message} = this.props;

    return (
      <div className="mv-message-modal">
        {header &&
          <div className="header">{localize(header)}</div>
        }
        <div className="message">
          {localize(message)}
        </div>
      </div>
    );
  }
};

MvMessageModal.contextType = LocalizationContext;
export {
  MvMessageModal,
};
